<table class="table">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">First</th>
        <th scope="col">Last</th>
        <th scope="col">Email</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of Users">
        <th scope="row">{{item.id}}</th>
        <td>{{item.name.split(' ')[0]}}</td>
        <td>{{item.name.split(' ')[1]}}</td>
        <td>{{item.email}}</td>
      </tr>
    </tbody>
  </table>